export const DataType = {
    string: 0,
    uint: 1,
    uid: 2,
    bool: 3,
    binary: 4,
    float: 5,
};
//# sourceMappingURL=types.js.map